import packageJson from '../../package.json';
import { EnvironmentConfig } from '../app/core/models';

export const environment: EnvironmentConfig = {
  production: false,
  //apiUrl: 'https://pre-gasolina-api.alvaromaxter.es/api/v1',
  apiUrl: 'https://pre-api.gasolinaradar.es/api/v1',
  name: 'test',
  appVersion: packageJson.version,
  googleClientId: '708829802900-6cs0c433ee9bm5a1ql34j63fsgtmqdr9.apps.googleusercontent.com',
};
